import React from 'react';

const ProductsMockup = () => {
  return (
    <div className="mockup-container products-mockup">
      <div className="mockup-header-bar">
        <div className="mockup-title">Catálogo de Productos y Suministros</div>
        <div className="filter-group">
          <span className="f-tag active">Todos</span>
          <span className="f-tag">Bebidas</span>
          <span className="f-tag">Accesorios</span>
        </div>
      </div>

      <div className="products-grid">
        <div className="p-item-card">
          <div className="p-img-thumb"></div>
          <div className="p-details">
            <span className="p-n">Agua Mineral 500ml</span>
            <span className="p-p">€1.50</span>
          </div>
          <div className="p-stock-line">Stock: 48 uds</div>
        </div>
        <div className="p-item-card">
          <div className="p-img-thumb alt"></div>
          <div className="p-details">
            <span className="p-n">Vaporizador de Mesa</span>
            <span className="p-p">€89.00</span>
          </div>
          <div className="p-stock-line">Stock: 12 uds</div>
        </div>
        <div className="p-item-card">
          <div className="p-img-thumb"></div>
          <div className="p-details">
            <span className="p-n">Refresco Cola</span>
            <span className="p-p">€2.00</span>
          </div>
          <div className="p-stock-line warning">Stock Bajo: 5 uds</div>
        </div>
        <div className="p-item-card">
          <div className="p-img-thumb alt"></div>
          <div className="p-details">
            <span className="p-n">Recipiente Hermético UV</span>
            <span className="p-p">€12.50</span>
          </div>
          <div className="p-stock-line">Stock: 32 uds</div>
        </div>
      </div>

      <style dangerouslySetInnerHTML={{ __html: `
        .products-mockup { background: white; border: 1px solid #e5e7eb; border-radius: 12px; padding: 24px; display: flex; flex-direction: column; gap: 20px; }
        .mockup-header-bar { display: flex; justify-content: space-between; align-items: center; }
        .filter-group { display: flex; gap: 8px; }
        .f-tag { font-size: 10px; font-weight: 600; padding: 4px 10px; background: #f3f4f6; border-radius: 6px; color: #6b7280; }
        .f-tag.active { background: #111827; color: white; }
        
        .products-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
        .p-item-card { background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 8px; padding: 12px; display: flex; flex-direction: column; gap: 8px; }
        .p-img-thumb { height: 60px; background: #e5e7eb; border-radius: 4px; }
        .p-img-thumb.alt { background: #d1d5db; }
        
        .p-details { display: flex; justify-content: space-between; align-items: center; }
        .p-n { font-size: 11px; font-weight: 700; color: #111827; }
        .p-p { font-size: 11px; font-weight: 700; color: #059669; }
        
        .p-stock-line { font-size: 10px; color: #6b7280; }
        .p-stock-line.warning { color: #dc2626; font-weight: 600; }
      `}} />
    </div>
  );
};

export default ProductsMockup;
